/* eslint-disable */
import React, { useRef, useEffect } from "react";
import logo from '../logo.svg';
import { ToastContainer, toast } from 'react-toastify';    
import 'react-toastify/dist/ReactToastify.css'; 
// import './App.css';
import '../assets/css/style.css';
import  Header  from './Header'
import Footer from './Footer';
import LoadingSpinner from './Loadingspinner'
import {baseUrl, defaultImages, ErrorMsgs, baseUrlSave, createBookingAPI, getAvailableBookingSlotAPI, setNewPasswordAPI, getAvailableServicesAPI, azureApiHeader, azureApiValue, phpBaseUrl, encryptionIv, encryptionKey, residential, commercials, ndis_self_managed, ndis_plan_manager, commercialsName, residentialName, ndis_self_managedName, ndis_plan_managerName} from './constant'
import {getAllServiceList, getAllServiceProviderList, savewebappdata, generateToken} from '../services/api/apiservices'
import {tConvert, dFormat, sampleJson, FilterServiceProviderList, SplitTimeSlots} from '../services/common/common';
import srImage from '../assets/images/user.jpg';
import ndisImage from '../assets/images/NDIS-logo.png';
import findExpertImg  from '../assets/images/find-expert.svg'
/* SVG Icons Step 2 */
import other from '../assets/images/other.svg';
import trade from '../assets/images/trade.svg';
import trees from '../assets/images/trees.svg';
import removals from '../assets/images/removals.svg';
import gardening from '../assets/images/gardening.svg';
import fencing from '../assets/images/fencing.svg';
import cleaning from '../assets/images/cleaning.svg';
import electrical from '../assets/images/electrical.svg';

import Moment from 'react-moment';
import 'moment-timezone';
import moment from 'moment';
import { data } from "jquery";
window.$payload = {}

// constructor(props) {
//     super(props);
  
//     this.state = {
//       query: '',
//       items: dataVar.items,
//     };
//   }

function Home() {

    // let date1 = new Date('2022-07-13T00:00:00Z');
    // console.log(tConvert('0'+date1.getUTCHours()+':0'+date1.getUTCMinutes()+':0'+date1.getUTCSeconds()));
    // let sJson = sampleJson();
    // let timesl = SplitTimeSlots('2022-07-20T00:00:00Z','2022-07-21T00:00:00Z');
    // console.log(timesl);
    // var d = new Date('2022-07-19T07:00:00');
    // var n = new Date(d.toISOString());
    // console.log(d.toLocaleString('en-AU', { timeZone: 'Australia/Melbourne' }));
    // console.log('filtered_Resource ',FilterServiceProviderList(sJson));
    


   
  
const currentDate = new Date();
let cdate = currentDate.getFullYear()+'-'+((currentDate.getMonth()+1) < 10 ? '0'+(currentDate.getMonth()+1) : (currentDate.getMonth()+1))
            +'-'+((currentDate.getDate() < 10) ? '0'+(currentDate.getDate()) : currentDate.getDate());  

// console.log(cdate.toString())

    const [currentStep, setCurrentStep] = React.useState(1);
    const [successMsg, setSuccess] = React.useState('');
    const [errorMsg, setError] = React.useState([]);

    
    //For step1
    const [postcode, setPostcode] = React.useState('');
    // const [servicedate, setServicedate] = React.useState(cdate.toString());
    const [servicedate, setServicedate] = React.useState(cdate);
    const [service_type, setServicetype] = React.useState('');

    //for step2
    const [service, setService] = React.useState('');
    const [sverror, setErrorService] = React.useState('');
    const [svisLoaded, setsvIsLoaded] = React.useState(false);
    const [svitems, setsvItems] = React.useState([]);

    //for step3
    const [firstname, setFirstname] = React.useState('');
    const [lastname, setLastname] = React.useState('');
    const [contact, setContact] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [address, setAdderss] = React.useState('');
    const [suburb, setSuburb] = React.useState('');
    const [s_state, setS_state] = React.useState('');
    const [jobdetails, setJobdetails] = React.useState('');
    const [ndis_registration_id, setNdis_regId] = React.useState('')

    // service type == NDIS - Plan manager
    const [customerFirstName, setCustomerFirstname] = React.useState('') 
    const [customerLastName, setCustomerLastname] = React.useState('')
    const [customerContact, setCustomerContact] = React.useState('')
    const [customerEmail, setCustomerEmail] = React.useState('')
    const [customerAddress, setCustomerAddress] = React.useState('');
    const [customerSuburb, setCustomerSuburb] = React.useState('');
    const [customerState, setCustomerState] = React.useState('');
    const [customerNdis_registration_id, setCustomerNdis_regId] = React.useState('');

    //for step4
    const [providerList, setProviderList] = React.useState([]);
    const [service_provider, setServiceProvider] = React.useState('');
    const [service_provider_name, setServiceProviderName] = React.useState('');
    const [startTime, setStarttime] = React.useState('');
    const [endTime, setEndtime] = React.useState('');
    const [arrivalTime, setArrivaltime] = React.useState('');
    const [showDiv, setShowDiv] = React.useState({});

    const [srerror, setServiceError] = React.useState(null);
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [items, setItems] = React.useState([]);

    const [otherServices, setOtheServices] = React.useState([]);

    const [isActive, setActive] = React.useState("false");
    const handleToggle = () => { setActive(!isActive); }; 
    
    const ref = useRef(null);
    const refsp = useRef(null);
      
    const step2 = () => {
        console.log("Step 2 Service Selected");
    };

    const step4 = () => {
        console.log("Step 4 Book Button Clicked");
    };

    const toggleHide = index => {
        setShowDiv({ ...showDiv, [index]: !showDiv[index] });
    };

    const showToastMessage = (msg) => {
        console.log('msgmsg ', msg)
        toast.error(msg, {
            position: toast.POSITION.TOP_RIGHT
        });
    };
    

    const getServiceList = async () => {
        setsvIsLoaded(true);
        const getToken = await generateToken();

        if(getToken.error == true){
            showToastMessage(getToken.message);
            gotoNext(1);
        }else{
            const servicelist = await getAllServiceList(getToken);
            console.log(servicelist.error)
            if(servicelist.error){
                showToastMessage(getToken.message);
                gotoNext(1);
                setsvIsLoaded(false);
            }else{
                setsvIsLoaded(false);
                const services = servicelist.data.sort((a, b) => a.name > b.name ? 1 : -1);
                const otherServiceData = servicelist.data.filter((item => item.name.toLowerCase() == 'other'));
                setOtheServices(otherServiceData);
                setsvItems(services);
            }
        }
    }


    const validateStep1 = () => {
        
        let flag = true;
        let regexpostcode = /^(0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2})$/
        if(postcode == ''){
            setError({postcode : ErrorMsgs.firstStep.postcode});
            flag = false;
        }else if(!regexpostcode.test(postcode)){
            setError({postcode : ErrorMsgs.firstStep.postcodeValid});
            flag = false;
        }else if(servicedate == '' || servicedate===undefined){
            setError({servicedate : ErrorMsgs.firstStep.servicedate});
            flag = false;
        }else if(service_type == ''){
            setError({servicetype : ErrorMsgs.firstStep.serviceType});
            flag = false;
        }else{
            flag = true;
        }

        if(flag){
            let payload1 = {
                postcode:postcode,
                servicedate: new Date(servicedate).toISOString(),
                service_type: service_type,
            }
            window.$payload = payload1
            
            getServiceList();
            gotoNext(2);
        }
    }


    const getServiceProviderList = async () => {
        setIsLoaded(true)
        let sdate = new Date(servicedate).toISOString();

        let IsNDISSelfManaged = false;
        if(parseInt(service_type) == ndis_self_managed){
            IsNDISSelfManaged = true;
        }

        let payl = {
            PostalCode:postcode,
            Service:service,
            fromdate:sdate,
            todate:sdate,
            IsNDISSelfManaged: IsNDISSelfManaged
        }

        const getToken = await generateToken();

        if(getToken.error == true){
            showToastMessage(getToken.message);
            gotoNext(3);
        }else{
		
            const resp = await getAllServiceProviderList(JSON.stringify(payl), getToken);
            if(resp.error){
                showToastMessage(getToken.message);
		        gotoNext(3);
                setIsLoaded(false)
            }else{
                setIsLoaded(false)
                let sdata = resp.data;
                if(sdata && sdata.length > 0){
                        const spData = sdata.sort((a, b) => a['Image.npw_tierpercentage'] > b['Image.npw_tierpercentage'] ? 1 : -1);
                        var testArray = [];
                        var result = [];
                        var spResult = [];
                        var i = 0;
                        var f = 0;
                        spData.map((item,index) => {

                            if(item['statuscode'] == 1){
                                if(testArray.indexOf(item['name']) > -1){
                                    result.map((r,ri)=>{
                                        if(item['name'] == r['name']){
                                            var temp = r['skill'];
                                            r['skill'] = temp+', '+item['SkillName.name'];

                                            if(r['ndis'] != true){
                                                if(item['SkillName.name'] == service && item['Xrm.npw_ndisserviceprovider'] == true){
                                                    r['ndis'] = true;
                                                }else{
                                                    r['ndis'] = false;
                                                }
                                            }
                                        }
                                    })
                                }else{
                                    var t = [];
                                    t['name'] =  item['name'];
                                    t['bookableresourceid'] =  item['bookableresourceid'];
                                    t['Image'] =  item['Image.entityimage'];
                                    t['skill'] =  item['SkillName.name'];
                                    // t['ndis'] = item['Xrm.npw_ndisserviceprovider'];

                                    if(item['SkillName.name'] == service && item['Xrm.npw_ndisserviceprovider'] == true){
                                        t['ndis'] = true;
                                    }else{
                                        t['ndis'] = false;
                                    }
                                    
                                    result.push(t);
                                    testArray.push(item['name']);
                                }
                                i = i+1;
                            }
                        });

                        result.map((spItem,ind) => {
                            var spSkill = spItem.skill;
                            const spArr = spSkill.split(', ');

                            if(spArr.indexOf(service) > -1){
                                spResult.push(spItem);
                                f = f+1;
                            }
                        });

                        console.log(spResult)

                        // if(i > 0){
                        if(f > 0){
                            setItems(spResult);
                            // setItems(result);
                            gotoNext(4);
                        }else{
                            window.$payload['resource_selected'] = false;
                            submitData(6);
                        }
                }else{
                    window.$payload['resource_selected'] = false;
                    submitData(6);
                }
            }   
        }
    }




    const validateStep3 = () => {
        let flag = true;
        var regName = /^[a-zA-Z]+$/;
        var regEmail = /^[\w]{1,}[\w.+-]{0,}@[\w-]{1,}([.][a-zA-Z]{2,}|[.][\w-]{2,}[.][a-zA-Z]{2,})$/

        if(firstname == ''){
            setError({firstname: ErrorMsgs.thirdStep.firstname});
            flag=false;
        }else if(!regName.test(firstname)){
            setError({firstname: ErrorMsgs.thirdStep.validfirstname});
            flag=false;
        }else if(lastname == ''){
            setError({lastname: ErrorMsgs.thirdStep.lastname});
            flag=false;
        }else if(!regName.test(lastname)){
            setError({lastname: ErrorMsgs.thirdStep.validlastname});
            flag=false;
        }else if(contact == ''){
            setError({contact: ErrorMsgs.thirdStep.contact});
            flag=false;
        }else if(contact.length < 10){
            setError({contact: ErrorMsgs.thirdStep.validcontact});
            flag=false;
        }else if(parseInt(contact) < 0){
            setError({contact: ErrorMsgs.thirdStep.validcontactnumber});
            flag=false;
        }else if(email == ''){
            setError({email: ErrorMsgs.thirdStep.email});
            flag=false;
        }else if(!regEmail.test(email)){
            setError({email: ErrorMsgs.thirdStep.validemail});
            flag=false;
        }else if(address == ''){
            setError({address: ErrorMsgs.thirdStep.address});
            flag=false;
        }else if(suburb == ''){
            setError({suburb: ErrorMsgs.thirdStep.suburb});
            flag=false;
        }else if(s_state == '' || s_state == null){
            setError({s_state: ErrorMsgs.thirdStep.state});
            flag=false;
        }else if( (parseInt(service_type) == ndis_plan_manager || (parseInt(service_type) == ndis_self_managed)) && ndis_registration_id == ''){
            setError({ndis_registration_id: ErrorMsgs.ndisFields.ndis_registration_id});
            flag=false;
        }else if(parseInt(service_type) == ndis_plan_manager && customerFirstName == ''){
            setError({customerFirstName: ErrorMsgs.ndisFields.customerFirstName});
            flag=false;
        }else if(parseInt(service_type) == ndis_plan_manager && customerLastName == ''){
            setError({customerLastName: ErrorMsgs.ndisFields.customerLastName});
            flag=false;
        }else if(parseInt(service_type) == ndis_plan_manager && customerContact == ''){
            setError({customerContact: ErrorMsgs.ndisFields.customerContact});
            flag=false;
        }else if(parseInt(service_type) == ndis_plan_manager && customerContact.length < 10){
            setError({customerContact: ErrorMsgs.thirdStep.validcontact});
            flag=false;
        }else if(parseInt(service_type) == ndis_plan_manager && parseInt(customerContact) < 0){
            setError({customerContact: ErrorMsgs.thirdStep.validcontactnumber});
            flag=false;
        }else if(parseInt(service_type) == ndis_plan_manager && customerEmail == ''){
            setError({customerEmail: ErrorMsgs.ndisFields.email});
            flag=false;
        }else if(parseInt(service_type) == ndis_plan_manager && !regEmail.test(customerEmail)){
            setError({customerEmail: ErrorMsgs.thirdStep.validemail});
            flag=false;
        }else if(parseInt(service_type) == ndis_plan_manager && customerAddress == ''){
            setError({customerAddress: ErrorMsgs.ndisFields.customerAddress});
            flag=false;
        }else if(parseInt(service_type) == ndis_plan_manager && customerSuburb == ''){
            setError({customerSuburb: ErrorMsgs.ndisFields.customerSuburb});
            flag=false;
        }else if(parseInt(service_type) == ndis_plan_manager && (customerState == '' || customerState == null)){
            setError({customerState: ErrorMsgs.ndisFields.customerState});
            flag=false;
        }else if(parseInt(service_type) == ndis_plan_manager && (customerNdis_registration_id == '' || customerNdis_registration_id == null)){
            setError({customerNdis_registration_id: ErrorMsgs.ndisFields.customerNdis_registration_id});
            flag=false;
        }else if(jobdetails.trim() == ''){
            setError({jobdetails: ErrorMsgs.thirdStep.jobdesc});
            flag=false;
        }else{
            flag = true;
        }

        if(flag){
            window.$payload['firstname'] = firstname;
            window.$payload['lastname'] = lastname;
            window.$payload['contact'] = contact;
            window.$payload['email'] = email;
            window.$payload['address'] = address+', , '+suburb+', '+s_state+', , '+postcode;
            window.$payload['jobdetails'] = jobdetails;

            if(parseInt(service_type) == ndis_plan_manager){
                window.$payload['custfirstname'] = customerFirstName;
                window.$payload['custlastname'] = customerLastName;
                window.$payload['custcontact'] = customerContact;
                window.$payload['custemail'] = customerEmail;
                window.$payload['custaddress'] = customerAddress+', , '+customerSuburb+', '+customerState+', , '+postcode;
                window.$payload['NDISRegistrationID'] = ndis_registration_id;
                window.$payload['CustNDISRegistrationID'] = customerNdis_registration_id;
                window.$payload['service_typeName'] = ndis_plan_managerName;
            }else{
                window.$payload['custfirstname'] = "";
                window.$payload['custlastname'] = "";
                window.$payload['custcontact'] = "";
                window.$payload['custemail'] = "";
                window.$payload['custaddress'] = "";
                window.$payload['NDISRegistrationID'] = "";
                window.$payload['CustNDISRegistrationID'] = customerNdis_registration_id;

                if(parseInt(service_type) == ndis_self_managed){
                    window.$payload['NDISRegistrationID'] = ndis_registration_id;
                    window.$payload['service_typeName'] = ndis_self_managedName;
                }else if(parseInt(service_type) == commercials){
                    window.$payload['service_typeName'] = commercialsName;
                }else if(parseInt(service_type) == residential){
                    window.$payload['service_typeName'] = residentialName;
                }
            }

            getServiceProviderList();
            gotoNext(4);
        }
        

    }
  
    const gotoNext = (step, isClearForms = false) => {
        setCurrentStep(step)
        if(isClearForms){
            clearAllForms();   
        }
        if (step === 1) {
            setServicedate(cdate);
        }
    }

    const clearErrorMsg = () => {
        setError([]);
    }

    const clearAllForms = () => {
        setPostcode(''); setServicedate(''); setServicetype('');
        setService(''); setFirstname(''); setLastname(''); setContact('');
        setEmail(''); setAdderss(''); setJobdetails(''); setServiceProvider('');
        setStarttime(''); setEndtime(''); setArrivaltime(''); setSuburb(''); setS_state('');

        window.$payload = {};
    }


    const utcConverterToLocalTimezone = (fechaUTC) => {
        var d = new Date(fechaUTC);
        d.toLocaleString('en-US', { timeZone: 'UTC' })
        return d;
    }

    const submitData = async (step) => {
        // make final api call here
        setIsLoaded(true);
        const getToken = await generateToken();
        if(getToken.error == true){
            showToastMessage(getToken.message);
            gotoNext(3);
        }else{
            const saveresp = await savewebappdata(JSON.stringify(window.$payload), getToken);
            if(saveresp.error){
                showToastMessage(saveresp.message);
		        gotoNext(3);
                setIsLoaded(false);
            }else if(!saveresp.data.status){
                setIsLoaded(false);
                alert('Something went wrong! please try again');
            }else{
                setIsLoaded(false);
                gotoNext(step);
            }
        }
    }

    const selectServiceProviderSlot = (date,from,to,arr,Id, selDate) => {
        let fromtime = date+'T'+moment(from, "hh:mm:ss").format("HH:mm:ss")+'Z';
        let endtime = date+'T'+moment(to, "hh:mm:ss").format("HH:mm:ss")+'Z';

        // let t = timeslot.split('|');
        // let t1 = t[0].split(' to ');
        // console.log(t1);
        window.$payload['StartTime'] = fromtime;
        window.$payload['Endtime'] = endtime;
        window.$payload['ArrivalTime'] = arr;
        setStarttime(selDate);
        setEndtime(endtime);
        setArrivaltime(arr);
        setServiceProvider(Id); 
        window.$payload['resourceid'] = Id;
        window.$payload['resource_selected'] = true;
        // gotoNext(5); 
        // submitData(5)
    }

    const selectServiceProvider = (id) => {

        let utc = moment().utc();
        let date = new Date(utc.year(), utc.month(), utc.date(), utc.hour(), utc.minute(), utc.second(), utc.millisecond());
        // let fromtime = utc.year()+'-'+utc.month()+'-'+utc.date()+'T'+utc.hour()+':'+utc.minute()+':'+utc.second()+'Z';
        let fromtime = utc.year() + '-' + ('0' + (utc.month() + 1)).slice(-2) + '-' + ('0' + (utc.date())).slice(-2) + 'T' + ('0' + (utc.hour())).slice(-2) + ':' + ('0' + (utc.minute())).slice(-2) + ':' + ('0' + (utc.second())).slice(-2) + 'Z';
        let utcAddMins = moment().utc().add(30, 'minutes');
        let dateAddMins = new Date(utcAddMins.year(), utcAddMins.month(), utcAddMins.date(), utcAddMins.hour(), utcAddMins.minute(), utcAddMins.second(), utcAddMins.millisecond());
        // let endtime = utcAddMins.year()+'-'+utcAddMins.month()+'-'+utcAddMins.date()+'T'+utcAddMins.hour()+':'+utcAddMins.minute()+':'+utcAddMins.second()+'Z';
        let endtime = utcAddMins.year() + '-' + ('0' + (utcAddMins.month() + 1)).slice(-2) + '-' + ('0' + (utcAddMins.date())).slice(-2) + 'T' + ('0' + (utcAddMins.hour())).slice(-2) + ':' + ('0' + (utcAddMins.minute())).slice(-2) + ':' + ('0' + (utcAddMins.second())).slice(-2) + 'Z';

        // if(!window.$payload['StartTime']){
        //     alert('please pick service time');
        // }else if(window.$payload['resourceid'] && window.$payload['resourceid'] !== id){
        //     delete window.$payload['StartTime'];
        //     delete window.$payload['Endtime'];
        //     delete window.$payload['ArrivalTime'];
        //     delete window.$payload['resourceid'];
        //     delete window.$payload['resource_selected'];
        //     setServiceProvider('');
        //     setStarttime('');
        //     setEndtime('');
        //     setArrivaltime('');
        //     alert('please pick service time');    
        // }else{
            window.$payload['StartTime'] = fromtime;
            window.$payload['Endtime'] = endtime;
            window.$payload['ArrivalTime'] = endtime;
            setStarttime(fromtime);
            setEndtime(endtime);
            setArrivaltime(endtime);

            setServiceProvider(id); 
            window.$payload['resourceid'] = id;
            window.$payload['resource_selected'] = true;
            submitData(5)
            // gotoNext(5); 
        // }
    }
    let sdate = new Date(servicedate);
    sdate =  sdate.getDate()+'/'+((sdate.getMonth()+1) < 10 ? '0'+(sdate.getMonth()+1) : (sdate.getMonth()+1))+'/'+sdate.getFullYear();
    

    if(currentStep === 1){
      
        return(
            <React.Fragment>
                <Header step1={currentStep}/>
            <div className="page-wrapper d-flex">
                
                <div className="sidebar get-started">
                    <div className="sidebar-inner">
                    <h4>obligation free quote</h4>
                    <h2>Request a quote from a Local Expert</h2>
                    <p>It’s quick and easy to request quotes for the work you need done. Simply select a service and request a quote.</p>			
                </div>
                <button className="btn" id="return-home-sidebar" onClick={() =>  {window.location.href='https://localexpert.com.au/'}}>return home</button>
                </div>
                <div className="page-content">
                    <div className="page-content-inner">
                    <div className="page-heading">
                    <h2>Make an enquiry</h2>
                    {/* <p>Fames ut cras sed nulla varius eu. Arcu fusce nisi, eu neque tempus eget eget dictumst. Ac integer diam nibh consequat.</p> */}
                </div>
                    <form className="enquiry-form-step-1 d-flex getting-started" method="post" action="#">
                        <div class="form-group">
                            <label>Enter your postcode</label>
                            <input type="text" className="form-input" value={postcode} maxLength="4" onInput={e => {  clearErrorMsg(); setPostcode(e.target.value)}} name="postcode" placeholder="0000" />
                            {errorMsg && <label style={{'color':'red'}}>{errorMsg.postcode}</label>}
                        </div>	
                        <div className="form-group" style={{'display':'none'}}>
                            <label>Service date</label>
                            <input type="date"  min={cdate} value={servicedate || ''} onInput={e => { clearErrorMsg(); setServicedate(e.target.value)}}  className="form-input service_date" name="service_date" placeholder="DD-MM-YYYY" />
                            {errorMsg && <label style={{'color':'red'}}>{errorMsg.servicedate}</label>}
                        </div>			
                        <label class="type-of-service">Type of service</label>
                        <div class="form-group half-width radio-input">
                            <div class="radio-outer bottom-space">
                                <label htmlFor="residential">
                                <input id="residential" defaultChecked={parseInt(service_type)===residential}  type="radio" value={residential} onClick={e => { setServicetype(e.target.value)}} name="service_type" />
                                <span></span>
                                Residential</label>
                            </div>
                            <div class="radio-outer">
                                <label htmlFor="commercial">
                                <input id="commercial" defaultChecked={parseInt(service_type)===commercials} type="radio" value={commercials} onClick={e => { setServicetype(e.target.value)}} name="service_type" />
                                <span></span>
                                Commercial</label>
                            </div>
                            {errorMsg && <label style={{'color':'red'}}>{errorMsg.servicetype}</label>}
                        </div>	
                        <div class="form-group half-width radio-input">				
                            <div class="radio-outer bottom-space">
                                <label htmlFor="ndis_self_managed">
                                <input id="ndis_self_managed" defaultChecked={parseInt(service_type)===ndis_self_managed} type="radio" value={ndis_self_managed} onClick={e => { setServicetype(e.target.value)}} name="service_type" />
                                <span></span>
                                NDIS - Self Managed</label>
                            </div>
                            <div class="radio-outer">
                                <label htmlFor="ndis_plan_manager">
                                <input id="ndis_plan_manager" defaultChecked={parseInt(service_type)===ndis_plan_manager} type="radio" value={ndis_plan_manager} onClick={e => { setServicetype(e.target.value)}} name="service_type" />
                                <span></span>
                                NDIS - Plan Manager</label>
                            </div>
                        </div>
                        <div className="form-group button-group">
                            <button type="button" id="return-home-make-enquiry" className="btn mobile-btn" onClick={() =>  {window.location.href='https://localexpert.com.au/'}}>Return home</button>
                            <button type="button" id="step-1-make-enquiry" onClick={() => {validateStep1()}} className="btn btn-filled">Next</button>
                        </div>


                    {/* <div className="form-group half-width">
                        <label>Enter your postcode</label>
                        <input type="text" value={postcode} maxLength="4" onInput={e => {  clearErrorMsg(); setPostcode(e.target.value)}}  className="form-input" name="postcode" placeholder="0000" />
                        
                        {errorMsg && <label style={{'color':'red'}}>{errorMsg.postcode}</label>}
                        
                    </div>
                    <div className="form-group half-width" style={{'display':'none'}}>
                        <label>Service date</label>
                        <input type="date"  min={cdate} value={servicedate || ''} onInput={e => { clearErrorMsg(); setServicedate(e.target.value)}}  className="form-input service_date" name="service_date" placeholder="DD-MM-YYYY" />
                        {errorMsg && <label style={{'color':'red'}}>{errorMsg.servicedate}</label>}
                        
                    </div>
                    <div className="form-group half-width radio-input">
                        <label>Type of service</label>
                        <div className="radio-outer">
                            <label htmlFor="residential">
                            <input id="residential" defaultChecked={parseInt(service_type)===residential}  type="radio" value={residential} onClick={e => { setServicetype(e.target.value)}} name="service_type" />
                            <span></span>
                            Residential</label>
                        </div>
                        <div className="radio-outer">
                            <label htmlFor="commercial">
                            <input id="commercial" defaultChecked={parseInt(service_type)===commercials} type="radio" value={commercials} onClick={e => { setServicetype(e.target.value)}} name="service_type" />
                            <span></span>
                            Commercial</label>
                        </div>
                        <div className="radio-outer">
                            <label htmlFor="ndis_self_managed">
                            <input id="ndis_self_managed" defaultChecked={parseInt(service_type)===ndis_self_managed} type="radio" value={ndis_self_managed} onClick={e => { setServicetype(e.target.value)}} name="service_type" />
                            <span></span>
                            NDIS - Self Managed</label>
                        </div>
                        <div className="radio-outer">
                            <label htmlFor="ndis_plan_manager">
                            <input id="ndis_plan_manager" defaultChecked={parseInt(service_type)===ndis_plan_manager} type="radio" value={ndis_plan_manager} onClick={e => { setServicetype(e.target.value)}} name="service_type" />
                            <span></span>
                            NDIS - Plan Manager</label>
                        </div>
                        {errorMsg && <label style={{'color':'red'}}>{errorMsg.servicetype}</label>}
                    </div>	
                    <div className="form-group button-group">
                        <button type="button" id="return-home-make-enquiry" className="btn mobile-btn" onClick={() =>  {window.location.href='https://localexpert.com.au/'}}>Return home</button>
                        <button type="button" id="step-1-make-enquiry" onClick={() => {validateStep1()}} className="btn btn-filled">Next</button>
                    </div>	 */}
    
                    </form>
                </div>
                </div>
    
                <ToastContainer /> 
            </div>
            <Footer />
            </React.Fragment>
        )

   
}
if(currentStep === 2){
    

    if (sverror) {
        
        return (
            <React.Fragment>
                <Header step1={currentStep}/>
            <div className="page-wrapper d-flex">
            <div className="sidebar">
                    <div className="sidebar-inner">
                        <div className="sidebar-top">
                            <h4>obligation free quote</h4>
                            <h2>Request a quote from a Local Expert</h2>
                            <p>It’s quick and easy to request quotes for the work you need done. Simply select a service and request a quote.</p>
                        </div>
                        <div className="quote-box" onClick={handleToggle}>
                            <h2>Your quote so far...</h2>
                            <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Postcode</label><span>{postcode}</span></div>
                            <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Service date</label><span>{sdate}</span></div>
                        </div>

                    </div>
                    <button id="back-sidebar" onClick={() => {gotoNext(1)}} className="btn">Back</button>
                </div>
            <div className="page-content">
                <div className="page-content-inner">
                    <div className="page-heading">
                    <h2>Pick your service</h2>
                    </div>
                    Error: {srerror.message}
            </div>
            </div>
            <ToastContainer /> 
            </div>
            <Footer />
            </React.Fragment>
        )
    }else if(svisLoaded){
        
        return (
        <React.Fragment>
                <Header step1={currentStep}/>
            <div className="page-wrapper d-flex">
                <div className="sidebar">
                    <div className="sidebar-inner">
                        <div className="sidebar-top">
                            <h4>obligation free quote</h4>
                            <h2>Request a quote from a Local Expert</h2>
                            <p>It’s quick and easy to request quotes for the work you need done. Simply select a service and request a quote.</p>
                        </div>
                        <div className="quote-box" onClick={handleToggle}>
                            <h2>Your quote so far...</h2>
                            <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Postcode</label><span>{postcode}</span></div>
                            <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Service date</label><span>{sdate}</span></div>
                        </div>

                    </div>
                    <button id="back-sidebar" onClick={() => {gotoNext(1)}} className="btn">Back</button>
                </div>
            <div className="page-content">
                <div className="page-content-inner">
                    <div className="page-heading">
                    <h2>Pick your service</h2>
                    
                    </div>
                   <LoadingSpinner /><br/>
                   
            </div>
            </div>
            <ToastContainer /> 
            </div>
            <Footer />
            </React.Fragment>
        );
    }else {
        return(
            <React.Fragment>
                <Header step1={currentStep}/>
            <div className="page-wrapper d-flex">
                <div className="sidebar">
                    <div className="sidebar-inner">
                        <div className="sidebar-top">
                            <h4>obligation free quote</h4>
                            <h2>Request a quote from a Local Expert</h2>
                            <p>It’s quick and easy to request quotes for the work you need done. Simply select a service and request a quote.</p>
                        </div>
                        <div className="quote-box" onClick={handleToggle}>
                            <h2>Your quote so far...</h2>
                            <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Postcode</label><span>{postcode}</span></div>
                            {/* <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Service date</label><span>{sdate}</span></div> */}
                        </div>

                    </div>
                    <button id="back-sidebar" onClick={() => {gotoNext(1)}} className="btn">Back</button>
                </div>
                <div className="page-content">
                    <div className="page-content-inner">
                        <div className="page-heading">
                            <h2>Pick your service</h2>
                        </div>
                        
                        <div className="services_outer">
                        {svitems.map((item,index) => {
                            var bgImage = '';
                           
                            if(item.name.toLowerCase() == 'other') {
                                bgImage = other;
                            }else if(item.name.toLowerCase() == 'trade') {
                                bgImage = trade;
                            }else if(item.name.toLowerCase() == 'trees') {
                                bgImage = trees;
                            }else if(item.name.toLowerCase() == 'removals') {
                                bgImage = removals;
                            }else if(item.name.toLowerCase() == 'gardening') {
                                bgImage = gardening;
                            }else if(item.name.toLowerCase() == 'fencing') {
                                bgImage = fencing;
                            }else if(item.name.toLowerCase() == 'cleaning') {
                                bgImage = cleaning;
                            }else if(item.name.toLowerCase() == 'electrical') {
                                bgImage = electrical;
                            }
                            if(item.name.toLowerCase() != 'other'){
                                return(    
                                    <div key={index} htmlFor={item.name} onClick={() => { setService(item.name); gotoNext(3); window.$payload['service'] = item.name; ref.current.click()} } className="services-card" 
                                        style={(service === item.name) ? {'border':'2px solid #0054A6','backgroundImage':'url('+bgImage+')'} : {'backgroundImage':'url('+bgImage+')'}}>
                                        <h2>{item.name}</h2>
                                        <p>{item.description}</p>
                                    </div>
                                );
                            } 
                        })}
                        {otherServices?.map((item,index) => {
                            return (
                                <div key={index} htmlFor={item.name} onClick={() => { setService(item.name); gotoNext(3); window.$payload['service'] = item.name; ref.current.click()} } className="services-card" 
                                    style={(service === item.name) ? {'border':'2px solid #0054A6','backgroundImage':'url('+other+')'} : {'backgroundImage':'url('+other+')'}}>
                                    <h2>{item.name}</h2>
                                    <p>{item.description}</p>
                                </div>
                            );
                        })};
                        <button type="button" id="step-2-pick-your-service" onClick={step2} ref={ref} style={{'display':'none'}}>Next</button>
                        </div>  
                        <div className="form-group button-group mobile">
                            <button id="back-step-2" onClick={() => {gotoNext(1)}} className="btn btn-filled mobile-btn">Back</button>
                            <button type="button"  className="btn btn-filled">Next</button>

                        </div>
                    </div>
                </div>
                <ToastContainer /> 
            </div>
            <Footer />
           </React.Fragment>
        )
    }

   
}

if(currentStep === 3){

    


    return(
        <React.Fragment>
            <Header step1={currentStep}/>
        <div className="page-wrapper d-flex">
            <div className="sidebar">
                <div className="sidebar-inner">
                    <div className="sidebar-top">
                <h4>obligation free quote</h4>
                <h2>Request a quote from a Local Expert</h2>
                <p>It’s quick and easy to request quotes for the work you need done. Simply select a service and request a quote.</p>	
                </div>
                <div className="quote-box" onClick={handleToggle}>
                    <h2>Your quote so far...</h2>
                    <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Postcode</label><span>{postcode}</span></div>
                    {/* <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Service date</label><span>{sdate}</span></div> */}
                    <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Service type</label><span>{service}</span></div>
                </div>		
            </div>
            <button id="back-sidebar" onClick={() => {gotoNext(2)}} className="btn">Back</button>
        </div>
        <div className="page-content">
            <div className="page-content-inner">
            <div className="page-heading">
            <h2>Add your details</h2>
            {/* <p>Fames ut cras sed nulla varius eu. Arcu fusce nisi, eu neque tempus eget eget dictumst. Ac integer diam nibh consequat.</p> */}
        </div>
            {
                (parseInt(service_type) == residential || parseInt(service_type) == commercials || parseInt(service_type) == ndis_self_managed) ?
            
            <form className="enquiry-form d-flex getting-started" method="post" action="#">
            <div className="form-group half-width">
                <label>First name<span style={{'color':'red'}}>*</span></label>
                <input type="text" className="form-input" name="first_name" placeholder="First name" value={firstname} onChange={e => { clearErrorMsg(); setFirstname(e.target.value)}} />
                {errorMsg && <label style={{'color':'red'}}>{errorMsg.firstname}</label>}
            </div>
            <div className="form-group half-width">
                <label>Last name<span style={{'color':'red'}}>*</span></label>
                <input type="text" className="form-input" name="last_name" placeholder="Last name" value={lastname}  onChange={e => { clearErrorMsg(); setLastname(e.target.value)}}/>
                {errorMsg && <label style={{'color':'red'}}>{errorMsg.lastname}</label>}
            </div>
            <div className="form-group half-width">
                <label>Contact number<span style={{'color':'red'}}>*</span></label>
                <input type="number" className="form-input" name="contact" placeholder="0000 000 000" 
                    value={contact}  onChange={(e) => { if(e.target.value.length===11) return false; clearErrorMsg(); setContact(e.target.value)}}/>
                {errorMsg && <label style={{'color':'red'}}>{errorMsg.contact}</label>}
            </div>
            <div className="form-group half-width">
                <label>Email<span style={{'color':'red'}}>*</span></label>
                <input type="email" className="form-input" name="email" placeholder="example@gmail.com"
                    value={email}  onChange={e => { clearErrorMsg(); setEmail(e.target.value)}}/>
                    {errorMsg && <label style={{'color':'red'}}>{errorMsg.email}</label>}
            </div>
            <div className="form-group half-width">
                <label>Street address<span style={{'color':'red'}}>*</span></label>
                <input type="text" className="form-input" name="address" placeholder="100 example road"
                    value={address}  onChange={e => { clearErrorMsg(); setAdderss(e.target.value)}}/>
                    {errorMsg && <label style={{'color':'red'}}>{errorMsg.address}</label>}
            </div>
            <div className="form-group half-width">
                <label>Suburb<span style={{'color':'red'}}>*</span></label>
                <input type="text" className="form-input" name="suburb" placeholder="example street"
                    value={suburb}  onChange={e => { clearErrorMsg(); setSuburb(e.target.value)}}/>
                    {errorMsg && <label style={{'color':'red'}}>{errorMsg.suburb}</label>}
            </div>

            <div className="form-group half-width">
                <label>State<span style={{'color':'red'}}>*</span></label>
                {/* <input type="text" className="form-input" name="state" placeholder="example state"
                    value={s_state}  onChange={e => { clearErrorMsg(); setS_state(e.target.value)}}/> */}
                    <select className="form-input" onChange={(e) => { clearErrorMsg(); setS_state(e.target.value || null) }} defaultValue={s_state || ""}>
                    <option value="">Please Select</option>
                    <option value="ACT">ACT</option>
                    <option value="NSW">NSW</option>
                    <option value="NT">NT</option>
                    <option value="QLD">QLD</option>
                    <option value="SA">SA</option>
                    <option value="TAS">TAS</option>
                    <option value="VIC">VIC</option>
                    <option value="WA">WA</option>
                        
                    </select>
                    {errorMsg && <label style={{'color':'red'}}>{errorMsg.s_state}</label>}
            </div>
            
            {(parseInt(service_type) == ndis_self_managed || parseInt(service_type) == ndis_plan_manager) ?
                <div className="form-group half-width">
                    <label>NDIS registration ID<span style={{'color':'red'}}>*</span></label>
                    <input type="text" className="form-input" name="ndis_registration_id" placeholder="12345678"
                        value={ndis_registration_id}  onChange={e => { clearErrorMsg(); setNdis_regId(e.target.value)}}/>
                        {errorMsg && <label style={{'color':'red'}}>{errorMsg.ndis_registration_id}</label>}
                </div>
             : ''}

            
            <div className="form-group">
                <label>Job Details<span style={{'color':'red'}}>*</span></label>
                <textarea value={jobdetails} placeholder='Enter a description of your requirements here'  onChange={e => { clearErrorMsg(); setJobdetails(e.target.value)}}></textarea>
                {errorMsg && <label style={{'color':'red'}}>{errorMsg.jobdetails}</label>}
            </div>
                
            <div className="form-group button-group form-action">
                <button id="back-step-3" className="btn btn-outline mobile-only btn-green">Back</button>
                <button type="button" id="step-3-user-details" onClick={() => {validateStep3()}} className="btn btn-filled">Next</button>
            </div>	

            </form>
            : 
                
            <form className="enquiry-form d-flex getting-started" method="post" action="#">
                <div className="form-group half-width">
                    <label>Plan Manager First name<span style={{'color':'red'}}>*</span></label>
                    <input type="text" className="form-input" name="first_name" placeholder="First name" value={firstname} onChange={e => { clearErrorMsg(); setFirstname(e.target.value)}} />
                    {errorMsg && <label style={{'color':'red'}}>{errorMsg.firstname}</label>}
                </div>
                <div className="form-group half-width">
                    <label>Plan Manager Last name<span style={{'color':'red'}}>*</span></label>
                    <input type="text" className="form-input" name="last_name" placeholder="Last name" value={lastname}  onChange={e => { clearErrorMsg(); setLastname(e.target.value)}}/>
                    {errorMsg && <label style={{'color':'red'}}>{errorMsg.lastname}</label>}
                </div>
                <div className="form-group half-width">
                    <label>Contact number<span style={{'color':'red'}}>*</span></label>
                    <input type="number" className="form-input" name="contact" placeholder="0000 000 000" 
                        value={contact}  onChange={(e) => { if(e.target.value.length===11) return false; clearErrorMsg(); setContact(e.target.value)}}/>
                    {errorMsg && <label style={{'color':'red'}}>{errorMsg.contact}</label>}
                </div>
                <div className="form-group half-width">
                    <label>Email<span style={{'color':'red'}}>*</span></label>
                    <input type="email" className="form-input" name="email" placeholder="example@gmail.com"
                        value={email}  onChange={e => { clearErrorMsg(); setEmail(e.target.value)}}/>
                        {errorMsg && <label style={{'color':'red'}}>{errorMsg.email}</label>}
                </div>
                <div className="form-group half-width">
                    <label>Street address<span style={{'color':'red'}}>*</span></label>
                    <input type="text" className="form-input" name="address" placeholder="100 example road"
                        value={address}  onChange={e => { clearErrorMsg(); setAdderss(e.target.value)}}/>
                        {errorMsg && <label style={{'color':'red'}}>{errorMsg.address}</label>}
                </div>
                <div className="form-group half-width">
                    <label>Suburb<span style={{'color':'red'}}>*</span></label>
                    <input type="text" className="form-input" name="suburb" placeholder="example street"
                        value={suburb}  onChange={e => { clearErrorMsg(); setSuburb(e.target.value)}}/>
                        {errorMsg && <label style={{'color':'red'}}>{errorMsg.suburb}</label>}
                </div>

                <div className="form-group half-width">
                    <label>State<span style={{'color':'red'}}>*</span></label>
                    {/* <input type="text" className="form-input" name="state" placeholder="example state"
                        value={s_state}  onChange={e => { clearErrorMsg(); setS_state(e.target.value)}}/> */}
                        <select className="form-input" onChange={(e) => { clearErrorMsg(); setS_state(e.target.value || null) }} defaultValue={s_state || ""}>
                        <option value="">Please Select</option>
                        <option value="ACT">ACT</option>
                        <option value="NSW">NSW</option>
                        <option value="NT">NT</option>
                        <option value="QLD">QLD</option>
                        <option value="SA">SA</option>
                        <option value="TAS">TAS</option>
                        <option value="VIC">VIC</option>
                        <option value="WA">WA</option>            
                        </select>
                        {errorMsg && <label style={{'color':'red'}}>{errorMsg.s_state}</label>}
                </div>
                
                <div className="form-group half-width">
                    <label>NDIS registration ID<span style={{'color':'red'}}>*</span></label>
                    <input type="text" className="form-input" name="ndis_registration_id" placeholder="12345678"
                        value={ndis_registration_id}  onChange={e => { clearErrorMsg(); setNdis_regId(e.target.value)}}/>
                        {errorMsg && <label style={{'color':'red'}}>{errorMsg.ndis_registration_id}</label>}
                </div>
                
                <div className="form-group half-width" style={{'margin-top':'80px'}}>
                    <label>Customer First Name<span style={{'color':'red'}}>*</span></label>
                    <input type="text" className="form-input" name="customerFirstName" placeholder="first name"
                        value={customerFirstName}  onChange={e => { clearErrorMsg(); setCustomerFirstname(e.target.value)}}/>
                        {errorMsg && <label style={{'color':'red'}}>{errorMsg.customerFirstName}</label>}
                </div>
                <div className="form-group half-width" style={{'margin-top':'80px'}}>
                    <label>Customer Last Name<span style={{'color':'red'}}>*</span></label>
                    <input type="text" className="form-input" name="customerLastName" placeholder="last name"
                        value={customerLastName}  onChange={e => { clearErrorMsg(); setCustomerLastname(e.target.value)}}/>
                        {errorMsg && <label style={{'color':'red'}}>{errorMsg.customerLastName}</label>}
                </div>
                <div className="form-group half-width">
                    <label>Customer contact number<span style={{'color':'red'}}>*</span></label>
                    <input type="number" className="form-input" name="customerContact" placeholder="0000 000 000" 
                        value={customerContact}  onChange={(e) => { if(e.target.value.length===11) return false; clearErrorMsg(); setCustomerContact(e.target.value)}}/>
                    {errorMsg && <label style={{'color':'red'}}>{errorMsg.customerContact}</label>}
                </div>

                <div className="form-group half-width">
                    <label>Customer email<span style={{'color':'red'}}>*</span></label>
                    <input type="text" className="form-input" name="customerEmail" placeholder="example@gmail.com"
                        value={customerEmail}  onChange={e => { clearErrorMsg(); setCustomerEmail(e.target.value)}}/>
                        {errorMsg && <label style={{'color':'red'}}>{errorMsg.customerEmail}</label>}
                </div>
                <div className="form-group half-width">
                    <label>Customer Address<span style={{'color':'red'}}>*</span></label>
                    <input type="text" className="form-input" name="customerAddress" placeholder="100 example road"
                        value={customerAddress}  onChange={e => { clearErrorMsg(); setCustomerAddress(e.target.value)}}/>
                        {errorMsg && <label style={{'color':'red'}}>{errorMsg.customerAddress}</label>}
                </div>
                <div className="form-group half-width">
                    <label>Customer suburb<span style={{'color':'red'}}>*</span></label>
                    <input type="text" className="form-input" name="customerSuburb" placeholder="example street"
                        value={customerSuburb}  onChange={e => { clearErrorMsg(); setCustomerSuburb(e.target.value)}}/>
                        {errorMsg && <label style={{'color':'red'}}>{errorMsg.customerSuburb}</label>}
                </div>

                <div className="form-group half-width">
                    <label>Customer State<span style={{'color':'red'}}>*</span></label>
                    {/* <input type="text" className="form-input" name="state" placeholder="example state"
                        value={s_state}  onChange={e => { clearErrorMsg(); setS_state(e.target.value)}}/> */}
                        <select className="form-input" onChange={(e) => { clearErrorMsg(); setCustomerState(e.target.value || null) }} defaultValue={s_state || ""}>
                        <option value="">Please Select</option>
                        <option value="ACT">ACT</option>
                        <option value="NSW">NSW</option>
                        <option value="NT">NT</option>
                        <option value="QLD">QLD</option>
                        <option value="SA">SA</option>
                        <option value="TAS">TAS</option>
                        <option value="VIC">VIC</option>
                        <option value="WA">WA</option>
                            
                        </select>
                        {errorMsg && <label style={{'color':'red'}}>{errorMsg.customerState}</label>}
                </div>
                <div className="form-group half-width">
                    <label>Customer NDIS registration ID<span style={{'color':'red'}}>*</span></label>
                    <input type="text" className="form-input" name="customerNdis_registration_id" placeholder="12345678"
                        value={customerNdis_registration_id}  onChange={e => { clearErrorMsg(); setCustomerNdis_regId(e.target.value)}}/>
                        {errorMsg && <label style={{'color':'red'}}>{errorMsg.customerNdis_registration_id}</label>}
                </div>
                <div className="form-group">
                    <label>Job Details<span style={{'color':'red'}}>*</span></label>
                    <textarea value={jobdetails} placeholder='Enter a description of your requirements here'  onChange={e => { clearErrorMsg(); setJobdetails(e.target.value)}}></textarea>
                    {errorMsg && <label style={{'color':'red'}}>{errorMsg.jobdetails}</label>}
                </div>
                    
                <div className="form-group button-group form-action">
                    <button id="back-step-3" className="btn btn-outline mobile-only btn-green">Back</button>
                    <button type="button" id="step-3-user-details" onClick={() => {validateStep3()}} className="btn btn-filled">Next</button>
                </div>	

            </form>

            }
        </div>
        </div>
        <ToastContainer /> 
    </div>
    <Footer />
    </React.Fragment>
    )
}

if(currentStep ===4 ){
   
    if (srerror) {
        
        return (
            <React.Fragment>
                <Header step1={currentStep}/>
            <div className="page-wrapper d-flex">
            <div className="sidebar">
                <div className="sidebar-inner">
                <div className="sidebar-top">
                <h4>obligation free quote</h4>
                <h2>Request a quote from a Local Expert</h2>
                <p>It’s quick and easy to request quotes for the work you need done. Simply select a service and request a quote.</p>	
            </div>
                <div className="quote-box" onClick={handleToggle}>
                    <h2>Your quote so far...</h2>
                    <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Postcode</label><span>{postcode}</span></div>
                    {/* <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Service date</label><span>{sdate}</span></div> */}
                    <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Service type</label><span>{service}</span></div>
                </div>		
            </div>
            <button id="back-sidebar" onClick={() => { gotoNext(3); } } className="btn">Back</button>
            </div>
            <div className="page-content">
                <div className="page-content-inner">
                    <div className="page-heading">
                    {/* <h2>Select your service provider  </h2>
                    <p>Fames ut cras sed nulla varius eu. Arcu fusce nisi, eu neque tempus eget eget dictumst. Ac integer diam nibh consequat.</p> */}
                    </div>
                    Error: {srerror.message}
            </div>
            </div>

            </div>
            <Footer />
            </React.Fragment>
        )
    }else if(isLoaded){
        
        return (
        <React.Fragment>
                <Header step1={currentStep}/>
            <div className="page-wrapper d-flex">
            <div className="sidebar">
                <div className="sidebar-inner">
                <div className="sidebar-top">
                <h4>obligation free quote</h4>
                <h2>Request a quote from a Local Expert</h2>
                <p>It’s quick and easy to request quotes for the work you need done. Simply select a service and request a quote.</p>	
            </div>
                <div className="quote-box" onClick={handleToggle}>
                    <h2>Your quote so far...</h2>
                    <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Postcode</label><span>{postcode}</span></div>
                    {/* <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Service date</label><span>{sdate}</span></div> */}
                    <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Service type</label><span>{service}</span></div>
                </div>		
            </div>
            <button id="back-sidebar" onClick={() => { gotoNext(3); } } className="btn">Back</button>
            </div>
            <div className="page-content">
                <div className="page-content-inner">
                    <div className="page-heading">
                    {/* <h2>Select your service provider  </h2>
                    <p>Fames ut cras sed nulla varius eu. Arcu fusce nisi, eu neque tempus eget eget dictumst. Ac integer diam nibh consequat.</p> */}
                    </div>
                    <LoadingSpinner />
            </div>
            </div>

            </div>
            <Footer />
            </React.Fragment>
        );
    }else {
        let counts = {}
        let spImage = ""
        return (
        <React.Fragment>
        <Header step1={currentStep}/>
            <div className="page-wrapper d-flex">
                <div className="sidebar">
                    <div className="sidebar-inner">
                        <div className="sidebar-top">
                            <h4>obligation free quote</h4>
                            <h2>Request a quote from a Local Expert</h2>
                            <p>It’s quick and easy to request quotes for the work you need done. Simply select a service and request a quote.</p>	
                        </div>
                        <div className="quote-box" onClick={handleToggle}>
                            <h2>Your quote so far...</h2>
                            <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Postcode</label><span>{postcode}</span></div>
                            {/* <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Service date</label><span>{sdate}</span></div> */}
                            <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Service type</label><span>{service}</span></div>
                        </div>		
                    </div>
                    <button id="back-sidebar" onClick={() => { gotoNext(3); } } className="btn">Back</button>
                </div>
                <div className="page-content">
                    <div className="page-content-inner">
                        <div className="page-heading">
                            <h2>Select your service provider  </h2>
                            {/* <p>Fames ut cras sed nulla varius eu. Arcu fusce nisi, eu neque tempus eget eget dictumst. Ac integer diam nibh consequat.</p> */}
                        </div>
                        <div style={{'height':'800px','overflow':'scroll'}}>
                        {
                            items.map((item, index) => (

                                <div key={index} className={!showDiv[index] ? "ser_provider" : "ser_provider active"}>
                                    {/* <span className="tick2"></span> */}
                                    {
                                        item['Image'] ? 
                                            <span className="ser_avatar" style={{'background': 'url(\'data:image/jpeg;base64,'+item['Image']+'\')'}}></span> :
                                            <span className="ser_avatar" style={{'background': 'url('+srImage+')'}}></span>
                                    }
                                    <div className="ser_content">
                                        <span className="ser_availablitly">Available</span>
                                        <h2 onClick={() => { toggleHide(index)}}>{item.name}</h2>
                                        <div className="ser_tags">
                                            {/* <span>{service}</span> */}
                                            <span>{item['skill']}</span>
                                        </div>
                                    </div>
                                    {(item['ndis'] == true) ? 
                                    <div className="ser_ndis">
                                        <span className="ndisLogo" style={{'background': 'url('+ndisImage+')'}}></span>
                                    </div>
                                    : ''}
                                    <div className="ser_action">
                                        <button type="button" style={service_provider == item.bookableresourceid ? 
                                                {'background':'#0054A6','color':'#fff',borderColor:'#0054A6'} : 
                                                null} 
                                            onClick={() => { selectServiceProvider(item.bookableresourceid); setServiceProviderName(item.name); refsp.current.click() } }  className="btn btn-filled">Book</button>
                                    </div>
                                </div>
                            ))
                        }
                        </div>
                        <button type="button" id="step-4-select-sp" onClick={step4} ref={refsp} style={{'display':'none'}}>Next</button>
                    </div>
                </div>
            </div>
    <Footer />
    </React.Fragment>
        )
    }


}

if(currentStep === 5 ){
    
    return (
        <React.Fragment>
            <Header step1={currentStep}/>
        <div className="page-wrapper d-flex background-light">
            <div className="sidebar">
                <div className="sidebar-inner">
                    <div className="sidebar-top">
                    <h4>obligation free quote</h4>
                    <h2>Request a quote from a Local Expert</h2>
                    <p>It’s quick and easy to request quotes for the work you need done. Simply select a service and request a quote.</p>	
                </div>
                    <div className="quote-box" onClick={handleToggle}>
                        <h2>Your quote details</h2>
                        <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Postcode</label><span>{postcode}</span></div>
                        {/* <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Service date</label><span>{sdate}</span></div> */}
                        <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Service type</label><span>{service}</span></div>
                        <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Local expert</label><span>{service_provider_name}</span></div>
                    </div>		
                </div>
                {/* <button onClick={() => { gotoNext(4);} } className="btn">Back</button> */}
            </div>
            <div className="page-content thankyou-page get-expert">
                <div className="page-content-inner">
                    <h1>Thank you for requesting a quote</h1>
                    <div className="expert-detail">
                    <div className="expert-detail-inner">
                        <span className="expert-avatar rounded"><img src={srImage} /></span>
                        <p><strong>{service_provider_name}&nbsp;</strong> will be in touch shortly.</p></div>
                    </div>
                    <div className="form-group button-group">
                        <button id="step-5-add-another-services" onClick={() => {gotoNext(1, true)}} className="btn btn-outline btn-add">Add another service</button>
                        <button id="step-5-return-home" type="button" onClick={() =>  {window.location.href='https://localexpert.com.au/'}} className="btn btn-filled">return home</button>

                    </div>
                    
                </div>
            </div>

        </div>
        <Footer />
        </React.Fragment>
    )
}

if(currentStep === 6){
    
    return (
        <React.Fragment>
            <Header step1={currentStep}/>
        <div className="page-wrapper d-flex background-light">
            <div className="sidebar">
                <div className="sidebar-inner">
                    <div className="sidebar-top">
                    <h4>obligation free quote</h4>
                    <h2>Request a quote from a Local Expert</h2>
                    <p>It’s quick and easy to request quotes for the work you need done. Simply select a service and request a quote.</p>
                    </div>	
                    <div className="quote-box" onClick={handleToggle}>
                        <h2>Your quote details</h2>
                        <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Postcode</label><span>{postcode}</span></div>
                        <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Service date</label><span>{sdate}</span></div>
                        <div className={ isActive ? 'quote-row mobile-quote-row' : 'quote-row' }><label>Service type</label><span>{service}</span></div>
                    </div>		
                </div>
                <button id="back-sidebar" onClick={() => {gotoNext(1)}} className="btn">Back</button>
            </div>
            <div className="page-content thankyou-page search-expert">
                <div className="page-content-inner">
                    <h1>Thank you for reaching out to <br></br> Local Expert.</h1>
                    <div className="expert-detail">
                    <div className="expert-detail-inner" style={{'text-align':'center'}}>
                        {/* <span className="expert-avatar"><img src={findExpertImg} /></span> */}
                        <p>Unfortunately our service providers in your area are fully- <br></br> booked or unavailable at the moment.<br></br><br></br>
                        Our local expert team will contact you should we find an <br></br> alternative solution.</p>
                    </div>
                    </div>
                    <div className="form-group button-group">
                        <button id="step-5-add-another-services-not-found" onClick={() => {gotoNext(1, true)}} className="btn btn-outline btn-add">Add another service</button>
                        <button id="step-5-return-home-not-found" type="button" onClick={() =>  {window.location.href='https://localexpert.com.au/'}} className="btn btn-filled">return home</button>

                    </div>
                    
                </div>
            </div>

        </div>
        <Footer />
        </React.Fragment>
    )
}
}

export default Home;
